import { render, staticRenderFns } from "./LogIndex.vue?vue&type=template&id=6cafebe1"
import script from "./LogIndex.vue?vue&type=script&lang=js"
export * from "./LogIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports